import { WhatYouGetCardInterface } from '@/types/newTypes'
import clsx from 'clsx'
import React from 'react'

const WhatYouGet = () => {
  const items: WhatYouGetCardInterface[] = [
    {
      img: '/img/what-you-get/1.png',
      text: 'Fun Swipe-to-Clean Interface',
      gradient: 'red',
    },
    {
      img: '/img/what-you-get/2.png',
      text: 'Smart Cleanup Suggestions',
      gradient: 'purple',
    },
    {
      img: '/img/what-you-get/3.png',
      text: 'One-Tap Cleanup',
      gradient: 'yellow',
    },
    {
      img: '/img/what-you-get/4.png',
      text: 'Duplicate Photo Detection',
      gradient: 'green',
    },
    {
      img: '/img/what-you-get/5.png',
      text: 'Secret Folder',
      gradient: 'purple',
    },
    {
      img: '/img/what-you-get/6.png',
      text: 'Widgets',
      gradient: 'blue',
    },
    {
      img: '/img/what-you-get/7.png',
      text: 'Ad Blocker',
      gradient: 'blue',
    },
    {
      img: '/img/what-you-get/8.png',
      text: 'Charger Animation',
      gradient: 'red',
    },
  ]

  return (
    <section className="flex flex-col gap-6 mb-14 relative before:absolute before:w-[375px] before:h-[375px] before:-top-[50%] before:left-0 before:translate-y-1/2 before:bg-whatYouGetBg before:bg-no-repeat before:bg-[left_center]">
      <h2 className="text-center text-XL font-bold px-4">What you get</h2>
      <div className="grid grid-cols-1 max-small:place-items-center small:grid-cols-2 gap-4 max-w-minimum mx-auto w-full">
        {items.map((item, index) => (
          <div
            key={index}
            className="px-3 pt-4 pb-5 rounded-4.5xl min-h-[166px] max-w-[164px]"
            style={{
              background: clsx({
                'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(211, 58, 48, 0.5) 0%, rgba(211, 58, 48, 0) 100%), rgba(255, 255, 255, 0.08)':
                  item.gradient === 'red',
                'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(142, 59, 225, 0.5) 0%, rgba(142, 59, 225, 0) 100%), rgba(255, 255, 255, 0.08)':
                  item.gradient === 'purple',
                'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(255, 197, 86, 0.5) 0%, rgba(255, 197, 86, 0) 100%), rgba(255, 255, 255, 0.08)':
                  item.gradient === 'yellow',
                'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(39, 201, 119, 0.5) 0%, rgba(39, 201, 119, 0) 100%), rgba(255, 255, 255, 0.08)':
                  item.gradient === 'green',
                'radial-gradient(86.94% 86.96% at 40.55% 28.01%, rgba(70, 81, 255, 0.5) 0%, rgba(70, 81, 255, 0) 100%), rgba(255, 255, 255, 0.08)':
                  item.gradient === 'blue',
              }),
            }}
          >
            <img src={item.img} alt={item.text} />
            <p className="text-center text-logo font-semibold">{item.text}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default WhatYouGet
